import { fork } from 'redux-saga/effects' 

import { watchAuthApi } from './authSagas'
import { watchMyAssignmentApi } from './myAssignmentSagas'
import { watchPatientSagasApi } from './patientSagas'
import { watchVideoCallsApi } from './videoCallSagas'


export default function* getTheAllApiSaga() {

      yield fork(watchAuthApi);

      yield fork(watchMyAssignmentApi);

      yield fork(watchPatientSagasApi);

      yield fork(watchVideoCallsApi);

       
}


  
